import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import ProfileTab from "../../components/tab/profiletab";
import Spacer from "../../components/spacer/spacer";
import UnderHeaderMenu from "../../components/underheadermenu";

import { settingsItems } from "../../utils/arrayitems";
import useScreenSize from "../../utils/usescreensize";

import AccountSettings from "./accountsettings";
import Billing from "./billing";
import NotificationPref from "./notificationpref";
import Support from "./support";

import "./styles.css";

const Settings = () => {
  const screenSize = useScreenSize();
  const [searchParams, setSearchParams] = useSearchParams();
  const initialTab = searchParams.get("tab") || "accountSettings";
  const [activeTab, setActiveTab] = useState(initialTab);

  const handleTab = (name) => {
    setActiveTab(name);
    setSearchParams({ tab: name });
  };

  useEffect(() => {
    const tabParam = searchParams.get("tab");
    if (tabParam && tabParam !== activeTab) {
      setActiveTab(tabParam);
    }
  }, [searchParams]);

  return (
    <>
      {screenSize.width < 1023 && <UnderHeaderMenu titlename="Settings" />}
      <div className="settings-container">
        <div className="settings-top-part-container">
          {screenSize.width > 1023 && (
            <>
              <h1 className="settings-title">Settings</h1>
              <Spacer height="4px" />
            </>
          )}
          <p className="settings-subtitle">
            Manage your account, explore membership options, adjust notification
            settings, and get support when you need it.
          </p>
          <Spacer height="16px" />
          <div style={{ width: screenSize.width < 768 ? "100%" : "420px" }}>
            <ProfileTab
              tabItems={settingsItems}
              handleTab={handleTab}
              activeTab={activeTab}
              style={{
                background: "white",
                border: "1px solid #EAE6ED",
              }}
            />
          </div>
        </div>
        <div className="content-container">
          {activeTab === "accountSettings" && <AccountSettings />}
          {activeTab === "billing" && <Billing />}
          {activeTab === "notification" && <NotificationPref />}
          {activeTab === "support" && <Support />}
        </div>
      </div>
    </>
  );
};

export default Settings;
